export const RECAPTCHA_ACTIONS = {
  hireLogin: "hire_login",
  seekLogin: "seek_login",
  adminLogin: "admin_login",
  seekSignup: "seek_signup",
  hireSignup: "hire_signup",
  passwordRecovery: "password_recovery",
  resendVerification: "resend_verification",
  publicApply: "public_apply",
} as const;

export type RecaptchaAction = typeof RECAPTCHA_ACTIONS[keyof typeof RECAPTCHA_ACTIONS];

export const RECAPTCHA_PROTECTED_ACTIONS = Object.freeze(
  Object.values(RECAPTCHA_ACTIONS) as RecaptchaAction[],
);
